import React from "react";
import styles from "./PinLevelPermissionBadge.module.css";
import PropTypes from "prop-types";

/**
 * View component.
 * A badge that indicates what pin level permissions a feed has.
 */
export function PinLevelPermissionBadge({ pinLevelType }) {
  return (
    <span
      className={styles.badge}
      style={{
        backgroundColor:
          pinLevelType === "AssociateIbo"
            ? "#fff"
            : pinLevelType === "Platinum"
            ? "#e5eeef"
            : pinLevelType === "Emerald"
            ? "#bbd2d5"
            : "#91b6bb",
      }}
    >
      {pinLevelType === "AssociateIbo"
        ? "IBO"
        : pinLevelType === "Platinum"
        ? "PLA"
        : pinLevelType === "Emerald"
        ? "EM"
        : "DIA"}
    </span>
  );
}

PinLevelPermissionBadge.propTypes = {
  /**
   * String that determines the type (text & color) of the badge.
   */
  pinLevelType: PropTypes.oneOf(["AssociateIbo", "Platinum", "Emerald", "Diamond"]),
};
